/// <amd-module name="Agile/Directory/Components/DirectoryGrid/GroupRow" />
import { IGroupRow } from "Agile/Directory/Components/DirectoryGrid/DirectoryGrid.Props";
import { DirectoryCSS } from "Agile/Directory/Components/DirectoryGrid/DirectoryGridConstants";
import { DetailsRow, IColumn, IDetailsRowProps } from "OfficeFabric/DetailsList";
import { KeyCode } from "VSSUI/Util";
import * as React from "react";
import { css } from "VSS/Platform/Layout";
import { Tooltip } from "VSSUI/TooltipEx";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";

export interface IGroupRowProps extends IDetailsRowProps {
    columnKey: string;
    row: IGroupRow;
    onToggled: (row: IGroupRow, collapsed: boolean) => void;
}

export class GroupRow extends React.PureComponent<IGroupRowProps> {
    public render(): JSX.Element {
        const {
            row: { collapsed, title, toggleable }
        } = this.props;

        return (
            <div onClick={this._onClicked} onKeyDown={this._onKeyDown}>
                <DetailsRow
                    {...this.props}
                    aria-label={title}
                    aria-expanded={!collapsed}
                    onRenderItemColumn={this._renderCell}
                    className={css("directory-group-row", !toggleable && "directory-group-row--disabled")}
                />
            </div>
        );
    }

    private _renderCell = (row: IGroupRow, index: number, column: IColumn): JSX.Element | undefined => {
        if (column.key === this.props.columnKey) {
            return (
                <div className={DirectoryCSS.DIRECTORY_ROWITEM}>
                    {row.toggleable && (
                        <VssIcon
                            className={css("directory-group-chevron", !row.collapsed && "expanded")}
                            iconName="ChevronRight"
                            iconType={VssIconType.fabric}
                        />
                    )}
                    {row.iconProps && <VssIcon {...row.iconProps} className="directory-group-icon" />}
                    <Tooltip overflowOnly={true} text={row.title}>
                        <div className="directory-row-group-title">
                            <span className="flex-tooltip-host">{row.title}</span>
                        </div>
                    </Tooltip>
                </div>
            );
        }
    };

    private _onClicked = (): void => {
        const { row, onToggled } = this.props;

        if (onToggled && row.toggleable) {
            onToggled(row, !row.collapsed);
        }
    };

    private _onKeyDown = (event: React.KeyboardEvent<HTMLElement>): void => {
        const { row, onToggled } = this.props;

        if (onToggled && row.toggleable) {
            if ((!row.collapsed && event.keyCode === KeyCode.rightArrow) || (row.collapsed && event.keyCode === KeyCode.leftArrow)) {
                onToggled(row, !row.collapsed);
                event.preventDefault();
            }
        }
    };
}
